module.exports = __webpack_public_path__ + "static/media/about_us_footer_image.2749589c.svg";